import { GenderIdentity } from './types';

export const ADD_GENDER_IDENTITY = 'ADD_GENDER_IDENTITY';
export const REMOVE_GENDER_IDENTITY = 'REMOVE_GENDER_IDENTITY';
export const REINIT = 'REINIT';

interface AddGenderIdentityAction {
    type: typeof ADD_GENDER_IDENTITY;
    payload: GenderIdentity;
}

interface RemoveGenderIdentityAction {
    type: typeof REMOVE_GENDER_IDENTITY;
    payload: string; // patientid
}

interface ReinitAction {
    type: typeof REINIT;
}

export type GenderIdentityActionTypes = AddGenderIdentityAction | RemoveGenderIdentityAction | ReinitAction;

export const addGenderIdentity = (genderIdentity: GenderIdentity): GenderIdentityActionTypes => ({
    type: ADD_GENDER_IDENTITY,
    payload: genderIdentity,
});

export const removeGenderIdentity = (patientid: string): GenderIdentityActionTypes => ({
    type: REMOVE_GENDER_IDENTITY,
    payload: patientid,
});

export const renit = (): ReinitAction => ({
    type: REINIT,
});